import {Injectable} from '@angular/core';
import * as componentActions from '@catdetails/actions/sbd';
import {Store} from '@ngrx/store';

@Injectable()
export class SBDService {
  constructor(private store: Store<any>) {
  }

  setActive() {
    this.store.dispatch({type: componentActions.PROJECT_DETAILS_SBD_ACTIVATE});
  }

  setInActive() {
    this.store.dispatch({type: componentActions.PROJECT_DETAILS_SBD_DEACTIVATE});
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/project-details/services/sbd.service.ts